import React, { Fragment, useState } from "react"
import { Link, graphql } from "gatsby"
import NewsEventList from "../layouts/news-event-template"
import CardNewsEvent from "../components/custom-components/cardNewsEvent"
import "../css/custom-css/custom-news.css"
import Seo from "../components/seo"

const News = props => {
  const { data } = props
  const allPosts = data.getAllNews.edges
  const [searchState, setSearchState] = useState(false)

  const [state, setState] = useState({
    filteredData: [],
    query: "",
  })

  const handleInputChange = event => {
    const query = event.target.value
    if (query === "") {
      setSearchState(false)
    } else {
      const posts = data.getAllNews.edges || []
      const filteredData = posts.filter(post => {
        const { title } = post.node
        return title.toLowerCase().includes(query.toLowerCase())
      })

      setState({
        query,
        filteredData,
      })
      setSearchState(true)
    }
  }

  const { currentPage, newsNumPages } = props.pageContext
  const prevPage =
    currentPage - 1 === 1
      ? `/news-page/news`
      : `/news-page/news${currentPage - 1}`
  const nextPage = `/news-page/news${currentPage + 1}`

  const isFirst = currentPage === 1
  const isLast = currentPage === newsNumPages

  return (
    <Fragment>
      <Seo title="News" />

      <NewsEventList handleInputChange={handleInputChange}>
        <div class="row">
          {searchState
            ? state.filteredData.map(({ node }) => {
                return <CardNewsEvent key={data.id} data={node} />
              })
            : data.newsPost.edges.map(({ node }) => {
                return <CardNewsEvent key={data.id} data={node} />
              })}
        </div>

        <div class="pagination-bx clearfix m-b30 text-center col-md-12">
          {!searchState && (
            <ul class="pagination">
              <li class="previous">
                {!isFirst && (
                  <Link to={prevPage}>
                    <i class="ti-arrow-left"></i> Previous
                  </Link>
                )}
              </li>
              <li>
                {Array.from({ length: newsNumPages }, (_, i) => {
                  return (
                    <Link
                      key={i}
                      to={`/news-page/news${i === 0 ? "" : i + 1}`}
                      //   className={
                      //     i + 1 === currentPage
                      //       ? `${styles.link} ${styles.active}`
                      //       : `${styles.link}`
                      //   }
                    >
                      {i + 1}
                    </Link>
                  )
                })}
              </li>
              <li class="next">
                {!isLast && (
                  <Link to={nextPage}>
                    <i class="ti-arrow-right"></i> Next
                  </Link>
                )}
              </li>
            </ul>
          )}
        </div>
      </NewsEventList>
    </Fragment>
  )
}

export default News

export const query = graphql`
  query getNewsPost($skip: Int!, $limit: Int!) {
    newsPost: allContentfulNewsevents(
      skip: $skip
      limit: $limit
      sort: { fields: newsEventsDate, order: DESC }
      filter: { newsType: { eq: true } }
    ) {
      edges {
        node {
          slug
          title
          id: contentful_id
          descSingkat
          createdAt(formatString: "DD MMMM YYYY")
          newsEventsDate(formatString: "DD MMMM YYYY")
          images {
            fluid {
              ...GatsbyContentfulFluid
            }
            gatsbyImageData
          }
        }
      }
    }
    getAllNews: allContentfulNewsevents(filter: { newsType: { eq: true } }) {
      edges {
        node {
          slug
          title
          id: contentful_id
          descSingkat
          createdAt(formatString: "DD MMMM YYYY")
          newsEventsDate(formatString: "DD MMMM YYYY")
          images {
            fluid {
              ...GatsbyContentfulFluid
            }
            gatsbyImageData
          }
        }
      }
    }
  }
`

// export const newsQuery = graphql`
// {
//   allContentfulNewsevents (filter: {newsType: {eq: true}}){
//     nodes {
//       id
// 	  title
// 	  descSingkat
// 	  createdAt(formatString: "DD MMMM YYYY")
//       images {
//         gatsbyImageData
//       }
//       slug
//       description {
//         raw
//       }
//       newsType
//       eventsType
//     }
//   }
// }
// `
